import { Container } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import MUIDataTable from "mui-datatables"
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import LoadingUI from '../../../components/ui/LoadingUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import permissions from '../../../utils/Permissions'
const PendingBilling: React.FC = () => {
    const { t: _t } = useTranslation("General")
    const { t } = useTranslation("Mvm")
    const history = useHistory()

    const {user, hasPermission} = useAuth();

    const { isLoading, isFetching, data, refetch} = useQuery('pendingBilling', async () => {
        return await MvmApi.SearchPendingInvoicing(user.company.companyID, +user.company.plantID);
    } ,{
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        staleTime: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        refetch();
    }, [history, user])

    const handleAddMvmOutgoingInvoice = async (mvmId: number) => {
        await MvmApi.updateRackLoadBlockedUser(mvmId, +user.company.companyID)
            .then(() => {
                history.push(`AddMvmOutgoingInvoice/${mvmId}`)
            })
            .finally(() => {
                // setIsLoading(false)
            })

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.MVM.PendingBilling))
            history.replace('NoPermission');
    }, [history, user])

    const columns = [
            {
                name: 'mvmId',
                options: {
                    display: false,
                }
            },
            {
                name:  'mvmNumber',
                label: t("mvmNumber"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                      return (
                        <span style={{padding: 3, display: 'inline', color: '#597DDA', cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold'}} 
                            onClick={() => handleAddMvmOutgoingInvoice(tableMeta.rowData[0])}
                        >
                            {value}
                        </span>
                      );
                    }
                  }
            },
            {
                name: 'type',
                label: t("requestType"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                }
            },{
                name: 'local',
                label: t("local"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                }
            },{
                name: 'requestNumber',
                label: t("requestTNumber"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                }
            },{
                name: 'returnMessage',
                label: t("returnMessage"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "left"
                    }),
                }
            },{
                name: 'updatedAt',
                label: _t("updatedAt"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                        return utilsDate.DateTimeShort(value);
                    }
                }
            },{
                name: 'pendingResolutionUser',
                label: t("blockedUser"),
                options: {
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                      }),
                    setCellProps: () => ({
                        align: "center"
                    }),
                }
            },
    ]

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })


    return (
        <Container maxWidth={false} component="main">

            <PageTitle title={t("pendingBillingTitle")} />
                
                <div style={{marginTop: "0.2rem", marginBottom: "0.3rem", display: "grid"}}>
                    <span style={{fontWeight:"bold",fontSize:"0.8rem"}}> {_t("lastUpdate") + utilsDate.TimeByCompleteDate(new Date())} </span>
                    <span>{_t("totalRecords") + (data ? data.length : 0)}</span>
                </div>
                
                    {
                        isLoading || isFetching ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={data}
                                    columns={columns} 
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: true,
                                        pagination: false,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                       
                                    }}
                                    
                                />
                            </MuiThemeProvider>
                    }
        </Container>
    )
}
export default PendingBilling;
